export class DownloadFileError extends Error {
  constructor(message: string, name: string) {
    super(message);
    this.name = name;
  }
}
